module.exports = __webpack_public_path__ + "img/1500771960.03661e70.jpg";